import Repository from "./Repository";
const SENDEMAIL ="/sendEmail";
export default {
    sendEmailRepo(detail) {
      return Repository.post(`${SENDEMAIL}`,detail);
    }, 
  };